import { forwardRef } from 'react'

import { tv } from 'tailwind-variants'

import { Icon } from '../icon/icon'

export interface ButtonTrailingIconOptions {
  /** Material symbol appended after the label. Decorative; omitted for iconOnly. */
  trailingIcon?: string
  /** Optional hover motion, also governed by the button's animation settings. */
  trailingIconMotion?: 'none' | 'outward'
}

const trailingIconVariants = tv({
  variants: {
    motion: {
      none: '',
      outward:
        'transition-transform duration-200 group-hover/button:group-data-[motion-enabled]/button:-translate-y-0.5 group-hover/button:group-data-[motion-enabled]/button:translate-x-0.5'
    }
  }
})

export interface ButtonTrailingIconProps {
  name: string
  motion?: ButtonTrailingIconOptions['trailingIconMotion']
  className?: string
}

/** Also composable inside reserved-label layouts; motion follows the parent button. */
export const ButtonTrailingIcon = forwardRef<
  HTMLSpanElement,
  ButtonTrailingIconProps
>(({ name, motion = 'none', className }, ref) => (
  <Icon
    ref={ref}
    name={name}
    data-slot='button-trailing-icon'
    aria-hidden
    className={trailingIconVariants({ motion, className })}
  />
))
ButtonTrailingIcon.displayName = 'ButtonTrailingIcon'
